import React, { useState, useEffect } from 'react';
import './index.css';
import { NumericFormat } from 'react-number-format';
import {
  FormGroup,
  Container,
  Col,
  Row,
  Form,
  Input,
  Label,
} from 'reactstrap';
import { editDealer } from '../../../constants/apiCalls';
import { useNavigate, useLocation } from 'react-router-dom';
import ModalService from '../../../services/ModalService';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { DashBoardTitle } from '../../../Components/Title';
import { Breadcrumbs } from '../../../Components/Breadcrumbs/Breadcrumbs';
import Storage from '../../../services/Storage';
import { CommonButton } from '../../../Components/CommonComponents';
import { handleErrorMessage } from '../../../utils/utils';
import { dealerInfoAction } from '../../../reducers/DealerReducer';
import { useDispatch, useSelector } from 'react-redux';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const CreditLimitRiskMeasureTag = () => {
  const [isLoading, setIsloading] = useState(false);
  const [proposedCreditLimit, setProposedCreditLimit] = useState('');
  const [proposedRiskMeasrGrade, setProposedRiskMeasrGrade] = useState('');
  const [remarks, setRemarks] = useState('');
  const [businessInCash, setBusinessInCash] = useState('');
  const [businessInCredit, setBusinessInCredit] = useState('');
  const [isKycRequired, setIsKycRequired] = useState(false);
  let location = useLocation();
  const navigate = useNavigate();
  let stringArr = location.pathname.split(/(\d+)/);
  const [title, setTitle] = useState({});
  let userId = stringArr[1];

  const dispatch = useDispatch();
  const { dealerObj } = useSelector(state => state.DealerReducer);

  useEffect(() => {
    if (userId) {
      setIsloading(true);
      dispatch(dealerInfoAction(parseInt(userId), setIsloading));
    }
  }, []);

  useEffect(() => {
    setProposedCreditLimit(dealerObj.credit_limit);
    setProposedRiskMeasrGrade(dealerObj.risk_measure_tag);
    setRemarks(dealerObj.credit_limit_remarks);
    setBusinessInCash(dealerObj.expected_business_cash);
    setBusinessInCredit(dealerObj.expected_business_credit);
    setIsKycRequired(dealerObj.is_approved);
    setTitle({ name: dealerObj.business_name, page: dealerObj.page_4 });
  }, [dealerObj])

  const options = [
    { id: 1, name: 'A' },
    { id: 2, name: 'B' },
    { id: 3, name: 'C' },
    { id: 4, name: 'D' },
    { id: 5, name: 'E' },
  ];

  const handleChange = (e, key) => {
    let value = e.target.value;
    if (key === 1) {
      setProposedCreditLimit(value);
    } else if (key === 2) {
      setRemarks(value);
    } else if (key === 3) {
      setProposedRiskMeasrGrade(value);
    } else if (key === 4) {
      if (value < 0) value = 0;
      setBusinessInCash(value);
      if (value > 100) value = 100;
      setBusinessInCredit(100 - value);
      setBusinessInCash(value);
    }
  };

  const handleSaveAsDraft = (evt) => {
    evt.preventDefault();
    let payload = {
      id: userId,
      credit_limit: proposedCreditLimit,
      credit_limit_remarks: remarks,
      risk_measure_tag: proposedRiskMeasrGrade,
      expected_business_cash: businessInCash
        ? parseFloat(businessInCash)
        : null,
      expected_business_credit: businessInCredit,
      page_4: 0,
    };

    let fullPayload = {
      id: userId,
      credit_limit: proposedCreditLimit,
      credit_limit_remarks: remarks,
      risk_measure_tag: proposedRiskMeasrGrade,
      expected_business_cash: businessInCash
        ? parseFloat(businessInCash)
        : null,
      expected_business_credit: businessInCredit,
      page_4: 1,
    };

    if (
      payload.credit_limit == null ||
      payload.credit_limit_remarks == null ||
      payload.expected_business_cash == null ||
      payload.expected_business_credit == null
    ) {
      setIsloading(true);
      editDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          setTimeout(() => {
            const lastRoute = Storage.backBreadcrumbsButton();
            navigate(lastRoute.url, { replace: true });
          }, 3000);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
        }
        setIsloading(false);
      }, payload);
    }
    else if (
      payload.credit_limit &&
      payload.credit_limit_remarks &&
      payload.risk_measure_tag &&
      payload.expected_business_cash &&
      payload.expected_business_credit
    ) {
      setIsloading(true);
      editDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          setTimeout(() => {
            const lastRoute = Storage.backBreadcrumbsButton();
            navigate(lastRoute.url, { replace: true });
          }, 3000);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
        }
        setIsloading(false);
      }, fullPayload);
    }
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    let payload = {
      id: userId,
      credit_limit: proposedCreditLimit,
      credit_limit_remarks: remarks,
      risk_measure_tag: proposedRiskMeasrGrade,
      expected_business_cash: parseFloat(businessInCash),
      expected_business_credit: businessInCredit,
      page_4: 1,
    };

    if (payload.id) {
      setIsloading(true);
      editDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          setTimeout(() => {
            const lastRoute = Storage.backBreadcrumbsButton();
            navigate(lastRoute.url, { replace: true });
          }, 3000);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
        }
        setIsloading(false);
      }, payload);
    }
  };

  const handleBack = () => {
    const lastRoute = Storage.backBreadcrumbsButton();
    navigate(lastRoute.url, { replace: true });
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='CreditLimitRiskMeasureTag'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle
                          dashBorardName={
                            title.page === 1 ? title.name : 'New Dealer Registration'
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <Breadcrumbs title='Credit Limit & Risk Measure Tag' />
                    </Col>
                  </Row>
                  <div className='creditBlock'>
                    <div className='creditBlockInner'>
                      <Row>
                        <Col xs={12}>
                          <div className='dealerRegBlocktitle text-center noprint'>
                            Credit Limit & Risk Measure Tag
                          </div>
                        </Col>
                      </Row>
                      <Form onSubmit={handleSubmit}>
                        <Row>
                          <Col md={4}>
                            <div className='creditInput'>
                              <Label className='common-input-label'>
                                Credit Limit<span className='required'>*</span>
                              </Label>
                              <div className='d-flex creditLimitInputArea'>
                                <NumericFormat
                                  className='common-input w-100 creditLimitInput'
                                  type='text'
                                  required
                                  style={{ paddingLeft: '10px' }}
                                  thousandSeparator={true}
                                  autoComplete='off'
                                  thousandsGroupStyle='lakh'
                                  value={
                                    proposedCreditLimit === null ||
                                      proposedCreditLimit === 'undefined'
                                      ? ''
                                      : proposedCreditLimit
                                  }
                                  onChange={(e) => handleChange(e, 1)}
                                  placeholder='Proposed Credit Limit'
                                />
                                <Input value='₹' disabled className='rupeeIcon' />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <div className='creditInput'>
                              <FormGroup className='d-flex flex-column'>
                                <Label className='common-input-label'>Remarks</Label>
                                <Input
                                  type='textarea'
                                  className='address-area w-100'
                                  value={
                                    remarks === null || remarks === 'undefined'
                                      ? ''
                                      : remarks
                                  }
                                  placeholder='Type Here'
                                  onChange={(e) => handleChange(e, 2)}
                                  rows='5'
                                />
                              </FormGroup>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4}>
                            <div className='creditInput'>
                              <FormGroup className='mb-2'>
                                <Label className='common-input-label'>
                                  Proposed Risk Measure Tag
                                  <span className='required'>*</span>
                                </Label>
                                <div className='select-wrapper'>
                                  <Input
                                    type='select'
                                    value={
                                      proposedRiskMeasrGrade === null ||
                                        proposedRiskMeasrGrade === 'undefined'
                                        ? ''
                                        : proposedRiskMeasrGrade
                                    }
                                    id='select'
                                    required
                                    onChange={(e) => handleChange(e, 3)}
                                  >
                                    <option value={''}>Select</option>
                                    {options.length > 0 &&
                                      options.map((cheque, index) => {
                                        return (
                                          <option key={index} value={cheque.name}>
                                            {cheque.name}
                                          </option>
                                        );
                                      })}
                                  </Input>
                                </div>
                              </FormGroup>
                              <div className='commonNote exampleText'>
                                (Example: A-Excellent, B-Good, C-Moderate, D-Risky, E-High
                                Risky)
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <div className='creditInput'>
                              <div className='d-flex flex-column'>
                                <Label className='common-input-label'>
                                  Cash Credit Ratio<span className='required'>*</span>
                                </Label>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={3}>
                            <span className='common-input-label'>
                              Expected Business in Cash
                            </span>
                          </Col>
                          <Col md={2}>
                            <div className='d-flex'>
                              <Input
                                type='text'
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                value={
                                  businessInCash === null || businessInCash === 'undefined'
                                    ? ''
                                    : businessInCash
                                }
                                placeholder='Type Here'
                                autoComplete='off'
                                required
                                onChange={(e) => handleChange(e, 4)}
                              />
                              &nbsp;
                              <span className='pt-3'>%</span>
                            </div>
                          </Col>
                        </Row>
                        <Row className='pt-3'>
                          <Col md={3}>
                            <span className='common-input-label'>
                              Expected Business in Credit
                            </span>
                          </Col>
                          <Col md={2}>
                            <div className='d-flex'>
                              <Input
                                type='text'
                                required
                                onChange={(e) => handleChange(e, 5)}
                                max={100}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                value={
                                  businessInCredit === null ||
                                    businessInCredit === 'undefined'
                                    ? ''
                                    : businessInCredit
                                }
                                style={{ background: '#F4F5F5' }}
                                disabled
                                autoComplete='off'
                              />
                              &nbsp;
                              <span className='pt-3'>%</span>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <div className='common-buttons d-flex flex-wrap align-items-center justify-content-center'>
                              {isKycRequired ? (
                                <CommonButton name={'Cancel'} btnClass={'btnSecondary'} type="button" onClick={handleBack} />
                              ) : (
                                <CommonButton name={'Save as Draft'} btnClass={'btnSecondary'} type="button" onClick={handleSaveAsDraft} />
                              )}
                              <CommonButton name={'Submit'} btnClass={'btnPrimary'} type="submit" />
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </div>
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditLimitRiskMeasureTag;
